import React, { useState, useEffect } from 'react';

import { useGridApiRef } from '@mui/x-data-grid';

import { filterMethod } from '../../Helpers/helpers';

import { gridStyle } from '../shared/commonStyle';

import { DataGrid } from '@mui/x-data-grid';
import {
  Grid,
  Button,
  Modal,
  Box,
  Typography,
  Divider,
  Autocomplete,
  TextField,
} from '@mui/material';

import {
  NoHeaderTableUpdate,
  ReplaceValue,
  CustomerConstants,
} from '../../Helpers/requests';

import { useNavigate, useLocation } from 'react-router-dom';
import CustomCustomerToolbar from './CustomCustomerToolbar';
import { GetAuth } from '../../Auth/AuthProvider';
import { calculateNewValue } from '@testing-library/user-event/dist/utils';
import { FaceRetouchingNaturalOutlined } from '@mui/icons-material';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

// import { GridColDef } from '@mui/x-data-grid';

export default function CustomerList(props) {
  const returnLocation = useLocation();

  const navigateNew = useNavigate();
  //Define state
  const [categoriesData, setCategoriesData] = useState([]); //Constant - Categories List
  const [regionsData, setRegionsData] = useState([]); //Constant - Regions List
  const [data, setData] = useState([]); //data displayed in datagrid
  const [page, setPage] = useState(0); //Active page of table - starts at 0!
  const [filter, setFilter] = useState([]); //Current applied filter modal
  const [sort, setSort] = useState([]); //Current applied sorting modal
  const [loading, setLoading] = useState(false); //Loading indicator - used by datagrid
  const [, setActiveRow] = useState('NONE'); //Last row clicked - used in details (Detailbox) display
  const [pageSize, setPageSize] = useState(20); //Number of rows to display
  const [totalRows, setTotalRows] = useState(0); //Total Number of rows in set
  const [updateData, setUpdateData] = useState(0); //Increment to force update dataset
  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function

  const [fullFilterName, setFullFilterName] = useState('');
  const [fullFilterCategory, setFullFilterCategory] = useState('');
  const [fullFilterRegion, setFullFilterRegion] = useState('');

  const [fullFilterBlob, setFullFilterBlob] = useState([]);

  const [quickFilterVal, setQuickFilterVal] = useState(
    []
    // returnLocation.state.filtering || []
  );

  const [modalState, setModalState] = useState('notSet');

  const [modalEventFields, setModalEventFields] = useState({
    storeName: '',
    storeCategory: '',
    storeRegion: '',
  });

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [forceUpdateState, setForceUpdateState] = useState(1);

  const handleReturnState = () => {
    setModalEventFields({
      ...modalEventFields,
      storeName: returnLocation.state.listFields.storeName,
      storeCategory: returnLocation.state.listFields.storeCategory,
      storeRegion: returnLocation.state.listFields.storeRegion,
    });

    setFullFilterName(returnLocation.state.listFields.storeName);
    setFullFilterCategory(returnLocation.state.listFields.storeCategory.id);
    setFullFilterRegion(returnLocation.state.listFields.storeRegion.id);

    if (returnLocation.state.listFields.storeName !== '') {
      setModalState('isSet');
    } else if (returnLocation.state.listFields.storeCategory !== '') {
      setModalState('isSet');
    } else if (returnLocation.state.listFields.storeRegion !== '') {
      setModalState('isSet');
    } else {
      setModalState('notSet');
    }

    setPage(returnLocation.state.pageNum);
    setPageSize(returnLocation.state.pagesize);
    setSort(returnLocation.state.sorting);
    setFilter(returnLocation.state.filtering);
    setQuickFilterVal(returnLocation.state.filtering);

    // pageNum: page,
    // pagesize: pageSize,
    // sorting: sort,
    // filtering: filter,

    // if (returnLocation.state.filter.length > 0) {
    //   setFilter(returnLocation.state.filter);
    // }
  };

  const handleChange = (event) => {
    let checkEvent = event.target.id;

    switch (checkEvent) {
      case 'fullFilterName':
        setModalEventFields({
          ...modalEventFields,
          storeName: event.target.value,
        });
        break;
      default:
        break;
    }
  };

  const clearModalEntries = (e) => {
    e.preventDefault();
    setModalState('notSet');
    setModalEventFields({
      ...modalEventFields,
      storeName: '',
      storeCategory: '',
      storeRegion: '',
    });
    setFullFilterName('');
    setFullFilterRegion('');
    setFullFilterCategory('');
    setFullFilterBlob([]);
    // handleClose();
  };

  const handleFullFilter = (config) => {
    const { storeName, category, region } = config;

    const tmpBlob = [];
    storeName !== ''
      ? setFullFilterBlob([
          ...tmpBlob,
          {
            field: 'name',
            search: storeName,
            strict: false,
          },
        ])
      : setFullFilterBlob([...tmpBlob]);

    // console.log(fullFilterBlob);

    setModalState('isSet');
    handleClose();
  };

  const handleSubmit = (e) => {
    let category = modalEventFields.storeCategory.id;
    let region = modalEventFields.storeRegion.id;
    let store = modalEventFields.storeName;
    e.preventDefault();
    // console.log(store);

    handleFullFilter({
      storeName: store,
      category: category,
      region: region,
    });

    setFullFilterName(modalEventFields.storeName);
    setFullFilterCategory(category);
    setFullFilterRegion(region);

    setModalState('isSet');
    handleClose();
  };

  const filterCategoriesOptions = filterMethod;
  const filterRegionsOptions = filterMethod;

  const getNewCustomerFromCategory = async (event, newValue) => {
    let categoryValue;
    try {
      setModalEventFields({
        ...modalEventFields,
        storeCategory: newValue,
      });
      categoryValue = await newValue.id;
    } catch {
      categoryValue = null;
      return categoryValue;
    }
    // return getCustomerbyID(region, categoryValue, '%').then((data) => {
    //   setCustomerData(data.data.value);
    //   setStoreName(data.data.value[0].id);
    // });
  };
  const getNewCustomerFromRegion = async (event, newValue) => {
    let regionValue;
    try {
      setModalEventFields({
        ...modalEventFields,
        storeRegion: newValue,
      });
      regionValue = await newValue.id;
    } catch {
      regionValue = null;
      return regionValue;
    }
    // return getCustomerbyID(region, categoryValue, '%').then((data) => {
    //   setCustomerData(data.data.value);
    //   setStoreName(data.data.value[0].id);
    // });
  };

  useEffect(() => {
    CustomerConstants({
      resource: `/api/constants/customer`,
      setCategoriesFunc: setCategoriesData,
      setRegionsFunc: setRegionsData,
      setAsset_compFunc: () => {},
      setLoadingFunc: false,
      showNotification: enqNotification,
      logout,
    });
  }, [enqNotification, logout]);

  useEffect(() => {
    const returnInfo = returnLocation.state;
    if (returnInfo !== null) {
      handleReturnState();
    }
  }, [returnLocation]);

  // const handleFilterBlob = () => {
  //   console.log(
  //     'region',
  //     fullFilterName,
  //     'category',
  //     fullFilterCategory,
  //     'name',
  //     fullFilterRegion
  //   );
  // };

  useEffect(() => {
    NoHeaderTableUpdate(
      {
        resource: `/api/r2_customers`,
        setDataFunc: setData,
        pageNum: page,
        setLoadingFunc: setLoading,
        pagesize: pageSize,
        sorting: sort,
        filtering: filter,
        showNotification: enqNotification,
        setRows: setTotalRows,
        logout,
        fullFilterName: fullFilterName,
        fullFilterCategory: fullFilterCategory,
        fullFilterRegion: fullFilterRegion,
      },
      'customers'
    );
  }, [
    fullFilterName,
    fullFilterCategory,
    fullFilterRegion,
    page,
    pageSize,
    sort,
    filter,
    updateData,
    enqNotification,
    logout,
    forceUpdateState,
    fullFilterBlob,
  ]);

  //Configure columns for datagrid
  const columns = [
    {
      field: 'name',
      headerName: 'Customer Name',
      minWidth: 200,
      flex: 1,
      editable: false,
      require,
    },
    {
      field: 'category_name',
      headerName: 'Category',
      width: 200,
      flex: 1,
      editable: false,
      require,
      //valueGetter: ({ value }) => ReplaceValue(props.categoriesData, value),
    },
    {
      field: 'store_tel',
      headerName: 'Store Contact Number',
      minWidth: 200,
      flex: 1,
      editable: false,
      require,
    },
    {
      field: 'region_name',
      headerName: 'Region',
      width: 200,
      flex: 1,
      editable: false,
      require,
      //valueGetter: ({ value }) => ReplaceValue(props.regionsData, value),
    },

    //Custom "Actions" column - props.value is field value (id in this case)
    {
      field: 'actions',
      headerName: 'Actions',
      align: 'left',
      minWidth: 200,
      flex: 1,
      sortable: false,
      renderCell: (props) => (
        <>
          <Button
            variant='contained'
            size='small'
            onClick={() => {
              navigateNew(`/customer/customer_edit`, {
                replace: true,
                state: {
                  ...props.row,
                  returnInfo: {
                    pageNum: page,
                    pagesize: pageSize,
                    sorting: sort,
                    filtering: filter,
                    fullFilterName: fullFilterName,
                    fullFilterCategory: fullFilterCategory,
                    fullFilterRegion: fullFilterRegion,
                    listFields: modalEventFields,
                  },
                },
              });
            }}
          >
            Edit
          </Button>
        </>
      ),
    },
  ];

  return (
    <div style={{ minHeight: '79vh', maxWidth: '100%' }}>
      <div style={{ height: '79vh', maxWidth: '100%', marginBottom: 0 }}>
        <DataGrid
          sx={gridStyle}
          rows={data}
          rowCount={totalRows}
          loading={loading}
          pagination
          sortingMode='server'
          filterMode='server'
          onSortModelChange={(model) => {
            setPage(0);
            setSort(model);
          }}
          onFilterModelChange={(model) => {
            setPage(0);
            setFilter(model.quickFilterValues);
          }}
          page={page}
          pageSize={pageSize}
          paginationMode='server'
          onPageChange={(newPage) => {
            setPage(newPage);
          }}
          onPageSizeChange={(newPageSize) => {
            setPage(0);
            setPageSize(newPageSize);
            setData(data);
          }}
          columns={columns}
          onRowClick={(params) => {
            setActiveRow(params);
          }}
          initialState={{
            filter: {
              filterModel: {
                items: [],
                quickFilterValues:
                  returnLocation.state === null
                    ? []
                    : returnLocation.state.filtering,

                // returnlocation !== null ? returnLocation.state.filtering : [],

                // returnLocation.state.filtering || [],
                // returnLocation.state.filtering,
              },
            },
          }}
          QuickFilterClearIcon
          onRowDoubleClick={(params) => {
            setActiveRow(params);
            navigateNew(`/customer/customer_edit`, {
              replace: false,
              state: {
                ...params.row,
                returnInfo: {
                  pageNum: page,
                  pagesize: pageSize,
                  sorting: sort,
                  filtering: filter,
                  fullFilterName: fullFilterName,
                  fullFilterCategory: fullFilterCategory,
                  fullFilterRegion: fullFilterRegion,
                  listFields: modalEventFields,
                },
              },
              // returns: params,
            });
          }}
          rowsPerPageOptions={[20, 50, 100]}
          components={{ Toolbar: CustomCustomerToolbar }}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          componentsProps={{
            toolbar: {
              updateOnclick: () => {
                setUpdateData((i) => i + 1);
              },
              filterOnClick: () => {
                handleOpen();
              },
              modalState: modalState,
            },
          }}
        />
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-warrantee'
        aria-describedby='modal-warrantee-description'
      >
        <Box sx={modalStyle}>
          <form onSubmit={handleSubmit}>
            {' '}
            <Grid
              container
              rowSpacing={0}
              columnSpacing={{ xs: 1, sm: 1, md: 1 }}
              rowGap={{ xs: 1, sm: 1, md: 1 }}
              style={{
                background: '#84a1bc91',
                padding: '5px 10px 5px 5px',
                borderRadius: '5px',
              }}
            >
              <Grid item xs={12} md={12}>
                <Typography variant='h5' sx={{ height: 40 }}>
                  Filter
                </Typography>
                <Divider />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant='h6' sx={{ height: 40 }}>
                  Customer Name:
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  disabled={modalState === 'isSet' ? true : false}
                  name='fullFilterName'
                  id='fullFilterName'
                  size='small'
                  sx={{
                    width: '100%',
                    background: '#fff',
                    borderRadius: '5px',
                  }}
                  onChange={handleChange}
                  value={modalEventFields.storeName}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant='h6' sx={{ height: 40 }}>
                  Store Category:
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  disabled={modalState === 'isSet' ? true : false}
                  sx={{
                    width: '100%',
                    background: '#fff',
                    padding: 0,
                  }}
                  name='fullFilterCategory'
                  id='fullFilterCategory'
                  variant='standard'
                  size='small'
                  value={modalEventFields.storeCategory}
                  onChange={getNewCustomerFromCategory}
                  disablePortal
                  options={categoriesData}
                  filterOptions={filterCategoriesOptions}
                  getOptionLabel={(option) => option.name || ''}
                  renderInput={(params) => <TextField {...params} />}
                  isOptionEqualToValue={(option, value) => {
                    return option.id === value.id ? true : false;
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant='h6' sx={{ height: 40 }}>
                  Store Region:
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  disabled={modalState === 'isSet' ? true : false}
                  sx={{
                    width: '100%',
                    background: '#fff',
                    borderRadius: '5px',
                    padding: 0,
                  }}
                  name='fullFilterRegion'
                  id='fullFilterRegion'
                  variant='standard'
                  size='small'
                  value={modalEventFields.storeRegion}
                  onChange={getNewCustomerFromRegion}
                  disablePortal
                  options={regionsData}
                  filterOptions={filterRegionsOptions}
                  getOptionLabel={(option) => option.name || ''}
                  renderInput={(params) => <TextField {...params} />}
                  isOptionEqualToValue={(option, value) => {
                    return option.id === value.id ? true : false;
                  }}
                />
              </Grid>
            </Grid>
            <Button
              sx={{ margin: '20px 0 0 20px', float: 'right' }}
              variant='outlined'
              onClick={handleClose}
            >
              Close
            </Button>
            <Button
              sx={{ margin: '20px 0 0 20px', float: 'right' }}
              variant='contained'
              type='submit'
              color='success'
              className='btn btn-primary'
              onClick={clearModalEntries}
            >
              Clear Filter
            </Button>
            <Button
              sx={{ margin: '20px 0 0 0', float: 'right' }}
              variant='contained'
              type='submit'
              className='btn btn-primary'
              onClick={(e) => {
                handleSubmit(e);
                // handleFilterBlob();
              }}
              disabled={modalState === 'isSet' ? true : false}
            >
              Set Filter
            </Button>
          </form>
        </Box>
      </Modal>
    </div>
  );
}
